import { useContext } from 'react';

import { FieldsContext } from '../contexts';

export function useFields() {
  return useContext(FieldsContext);
}
